export const POSITION_FIELD_MAX_LENGTH = 2;

export const NONE = 'none';
export const DROPDOWN_OPTION_NONE = { id: NONE, name: 'None' };

export const DEFAULT_DELIMITER_OPTION = [{ id: ',', name: 'COMMA ( , )' }];
export const DEFAULT_END_OF_RECORD_OPTION = [{ id: 'NL', name: 'NEW LINE' }];

export const HEADER_FIELDS = {
  MAP_NAME: 'mapName',
  DELIMITER: 'delimiter',
  END_OF_RECORD_METHOD: 'endOfRecordMethod',
  SKIP_FIRST_RECORD: 'skipFirstRecord',
  STRIP_QUOTES: 'stripQuotes',
  ZERO_AMOUNT_FIELDS: 'zeroAmountFields'
};

export const TRANSACTION_FIELD_VARIANT = {
  // SWITCHER
  TRANSACTION_CODE: 'transactionCode',
  TRAN_TYPE: 'transactionType'
};

export const TABLE_FIELDS = {
  BANK_CODE: 'bankCode',
  TRAN_CODE: 'transactionCode',
  ACCOUNT_NUMBER: 'accountNumber',
  AMOUNT: 'amount',
  ID: 'id',
  NAME: 'name',
  DISC_DATA: 'discData',
  ADDENDA: 'addenda',
  TRAN_TYPE: 'transactionType',
  ACCOUNT_TYPE: 'accountType'
};

export const TABLE_FIELDS_NAMES = (locale) => ({
  [TABLE_FIELDS.BANK_CODE]: locale['common.bankCode'],
  [TABLE_FIELDS.TRAN_CODE]: locale['wireImports.transactionCode'],
  [TABLE_FIELDS.ACCOUNT_NUMBER]: locale['common.accountNumber'],
  [TABLE_FIELDS.AMOUNT]: locale['common.amount'],
  [TABLE_FIELDS.ID]: locale['common.id'],
  [TABLE_FIELDS.NAME]: locale['common.name'],
  [TABLE_FIELDS.DISC_DATA]: locale['wireImports.discData'],
  [TABLE_FIELDS.ADDENDA]: locale['common.addenda'],
  [TABLE_FIELDS.TRAN_TYPE]: locale['wireImports.transactionType'],
  [TABLE_FIELDS.ACCOUNT_TYPE]: locale['wireImports.accountType']
});

export const API_DETAIL_FIELDS_VOCABULARY = {
  bankCode: 'BANK_CODE',
  transactionCode: 'TRAN_CODE',
  accountNumber: 'ACCOUNT_NUMBER',
  amount: 'AMOUNT',
  id: 'ID',
  name: 'NAME',
  discData: 'DISC_DATA',
  addenda: 'ADDENDA',
  transactionType: 'TRAN_TYPE',
  accountType: 'ACCOUNT_TYPE'
};

export const getTableFields = (locale, dropdownData) => {
  const FIELD_NAME = TABLE_FIELDS_NAMES(locale);
  return [
    {
      id: TABLE_FIELDS.TRAN_CODE,
      name: FIELD_NAME[TABLE_FIELDS.TRAN_CODE],
      type: 'number',
      addValue: true,
      optional: false,
      match: true,
      update: true,
      fixedFormatLength: 2,
      dropdownData: dropdownData?.[TABLE_FIELDS.TRAN_CODE]
    },
    {
      id: TABLE_FIELDS.TRAN_TYPE,
      name: FIELD_NAME[TABLE_FIELDS.TRAN_TYPE],
      type: 'number',
      addValue: true,
      optional: false,
      match: true,
      update: true,
      dropdownData: dropdownData?.[TABLE_FIELDS.TRAN_TYPE]
    },
    {
      id: TABLE_FIELDS.ACCOUNT_TYPE,
      name: FIELD_NAME[TABLE_FIELDS.ACCOUNT_TYPE],
      type: 'number',
      addValue: true,
      optional: false,
      match: true,
      update: true,
      dropdownData: dropdownData?.[TABLE_FIELDS.ACCOUNT_TYPE]
    },
    {
      id: TABLE_FIELDS.BANK_CODE,
      name: FIELD_NAME[TABLE_FIELDS.BANK_CODE],
      type: 'number',
      addValue: true,
      optional: false,
      maxLength: 9,
      match: true,
      update: true,
      fixedFormatLength: 9
    },
    {
      id: TABLE_FIELDS.ACCOUNT_NUMBER,
      name: FIELD_NAME[TABLE_FIELDS.ACCOUNT_NUMBER],
      type: 'number',
      addValue: true,
      optional: false,
      maxLength: 17,
      match: true,
      update: true
    },
    {
      id: TABLE_FIELDS.AMOUNT,
      name: FIELD_NAME[TABLE_FIELDS.AMOUNT],
      type: 'number',
      addValue: true,
      optional: false,
      maxLength: 10,
      match: false,
      update: true
    },
    {
      id: TABLE_FIELDS.ID,
      name: FIELD_NAME[TABLE_FIELDS.ID],
      type: 'number',
      addValue: false,
      optional: true,
      maxLength: 15,
      match: true,
      update: false,
      fixedFormatLengthLimitation: 15
    },
    {
      id: TABLE_FIELDS.NAME,
      name: FIELD_NAME[TABLE_FIELDS.NAME],
      addValue: true,
      optional: false,
      maxLength: 22,
      match: true,
      update: true
    },
    {
      id: TABLE_FIELDS.DISC_DATA,
      name: FIELD_NAME[TABLE_FIELDS.DISC_DATA],
      type: 'number',
      addValue: true,
      optional: true,
      maxLength: 2,
      match: false,
      update: true,
      fixedFormatLength: 2
    },
    {
      id: TABLE_FIELDS.ADDENDA,
      name: FIELD_NAME[TABLE_FIELDS.ADDENDA],
      addValue: false,
      optional: true,
      maxLength: 80,
      match: false,
      update: true
    }
  ];
};

export const getOptionalTableFields = (locale) =>
  getTableFields(locale).filter((item) => item.optional);

export const FORM_NAMES = {
  DELIMITED: 'delimited',
  FIXED: 'fixed'
};

export const STORE_FORM_ACTIONS = {
  DELIMITED: FORM_NAMES.DELIMITED,
  FIXED: FORM_NAMES.FIXED,
  RESET: 'reset'
};

export const HEADER_CHECKBOXES_INITIAL_DATA = {
  [HEADER_FIELDS.SKIP_FIRST_RECORD]: undefined,
  [HEADER_FIELDS.STRIP_QUOTES]: undefined,
  [HEADER_FIELDS.ZERO_AMOUNT_FIELDS]: undefined
};

export const INITIAL_HEADERS_DATA = {
  DELIMITED: {
    [HEADER_FIELDS.DELIMITER]: DEFAULT_DELIMITER_OPTION,
    [HEADER_FIELDS.END_OF_RECORD_METHOD]: DEFAULT_END_OF_RECORD_OPTION
  },
  FIXED: {}
};

export const DEFAULT_TRAN_TYPE_ROW_DATA = {
  [`${TABLE_FIELDS.TRAN_TYPE}_addValue`]: [DROPDOWN_OPTION_NONE],
  [`${TABLE_FIELDS.ACCOUNT_TYPE}_addValue`]: [DROPDOWN_OPTION_NONE]
};

export const DEFAULT_TRAN_TYPE_DATA = {
  [`${TABLE_FIELDS.TRAN_CODE}_addValue`]: [DROPDOWN_OPTION_NONE],
  ...DEFAULT_TRAN_TYPE_ROW_DATA
};

export const DEFAULT_INITIAL_DATA = {
  DELIMITED: {
    ...DEFAULT_TRAN_TYPE_DATA,
    // headers
    ...INITIAL_HEADERS_DATA.DELIMITED,
    ...HEADER_CHECKBOXES_INITIAL_DATA
  },
  FIXED: {
    ...DEFAULT_TRAN_TYPE_DATA,
    // headers
    ...INITIAL_HEADERS_DATA.FIXED,
    ...HEADER_CHECKBOXES_INITIAL_DATA
  }
};

export const TRAN_TYPES_DATA = [
  { id: 'credit', name: 'Credit' },
  { id: 'debit', name: 'Debit' },
  { id: 'prenoteCredit', name: 'Prenote for Credit' },
  { id: 'prenoteDebit', name: 'Prenote for Debit' }
];

export const API_TRAN_TYPE_VOCABULARY = {
  creditType: 'credit',
  debitType: 'debit',
  prenoteCredit: 'prenoteCredit',
  prenoteDebit: 'prenoteDebit'
};

export const TRAN_TYPE_VOCABULARY = {
  credit: 'creditType',
  debit: 'debitType',
  prenoteCredit: 'prenoteCredit',
  prenoteDebit: 'prenoteDebit'
};

export const API_ACCOUNT_TYPE_VOCABULARY = {
  checkingType: 'checking',
  savingType: 'saving',
  loanType: 'loan',
  glType: 'generalLedger'
};

export const ACCOUNT_TYPE_VOCABULARY = {
  checking: 'checkingType',
  saving: 'savingType',
  loan: 'loanType',
  generalLedger: 'glType'
};

export const API_TRAN_TYPE_ROW_VOCABULARY = {
  ...API_TRAN_TYPE_VOCABULARY,
  ...API_ACCOUNT_TYPE_VOCABULARY
};

export const TRAN_TYPE_ROW_VOCABULARY = {
  ...TRAN_TYPE_VOCABULARY,
  ...ACCOUNT_TYPE_VOCABULARY
};

export const API_TRAN_TYPE_ROW_NAME_VOCABULARY = (locale) => ({
  credit: locale['wireImports.credit'],
  debit: locale['wireImports.debit'],
  prenoteCredit: locale['wireImports.prenoteCredit'],
  prenoteDebit: locale['wireImports.prenoteDebit'],
  checking: locale['wireImports.checking'],
  saving: locale['wireImports.saving'],
  loan: locale['wireImports.loan'],
  generalLedger: locale['wireImports.generalLedger']
});

export const TRAN_TYPES_DROPDOWN_DATA = [DROPDOWN_OPTION_NONE, ...TRAN_TYPES_DATA];

export const TRANSACTION_TYPE_ROWS = {
  'Transaction Type': ['debitType', 'creditType', 'prenoteDebit', 'prenoteCredit'],
  'Account Type': ['checkingType', 'savingType', 'loanType', 'glType']
};
